import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCompanyField } from "../../redux/actions/subscriptionActions";
import { getBlob, saveBlob } from "../../utils/idbBlobStorage";

export default function VideoRecorder({ onRecordingComplete }) {
  const videoRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const streamRef = useRef(null);
  const intervalRef = useRef(null);
  const { company } = useSelector((state) => state.subscription);
  const dispatch = useDispatch();
  const MAX_RECORDING_TIME = 300;
  const [recording, setRecording] = useState(false);
  const [videoUrl, setVideoUrl] = useState(null);
  const [recordingTime, setRecordingTime] = useState(0);
  const [error, setError] = useState(null);  
  const [loadingVideo, setLoadingVideo] = useState(true);

  useEffect(() => {
  (async () => {
    try {
      const savedBlob = await getBlob("maVideo");
      if (savedBlob) {
        const url = URL.createObjectURL(savedBlob);
        setVideoUrl(url);
      }
    } catch (err) {
      console.error("Erreur récupération blob sauvegardé:", err);
    } finally {
      setLoadingVideo(false);
    }
  })();
}, []);
  const startCamera = async () => {
    if (streamRef.current) {
      console.log("Camera already started.");
      return;
    }
    try {
      console.log("Starting camera...");
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true,
      });
      streamRef.current = mediaStream;
      if (videoRef.current) {
        videoRef.current.srcObject = mediaStream;
      }
    } catch (err) {
      console.error("Erreur accès caméra:", err);
      setError("Impossible d'accéder à la caméra.");
    }
  };

  const stopCamera = () => {
  if (streamRef.current) {
    console.log("Stopping camera...");
    streamRef.current.getTracks().forEach((track) => track.stop());
  }
  setTimeout(() => {
    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
    streamRef.current = null;
  }, 100);
};



  useEffect(() => {
    if (loadingVideo) return;

  if (company.modeSelectionVideo === "record" && !videoUrl) {
    startCamera();
  }
  return () => {
    stopCamera();
  };
}, [company.modeSelectionVideo,videoUrl,loadingVideo]);

  const startRecording = () => {
    if (!streamRef.current) return;

    const recorder = new MediaRecorder(streamRef.current, { mimeType: "video/webm" });
    const chunks = [];

    recorder.ondataavailable = (e) => {
      if (e.data.size > 0) {
        chunks.push(e.data);
      }
    };

    recorder.onstop = async () => {
      const blob = new Blob(chunks, { type: "video/webm" });
      const url = URL.createObjectURL(blob);
      setVideoUrl(url);
      try{
        await saveBlob("maVideo",blob);
        dispatch(setCompanyField("presentationVideoBase64", "maVideo"));
        

      }
      catch (err) {
        console.error("Erreur sauvegarde du blob impossible:", err);
      }

      onRecordingComplete?.(blob);
      stopCamera();
      clearInterval(intervalRef.current);
      setRecordingTime(0);
    };

    recorder.start();
    mediaRecorderRef.current = recorder;
    setRecording(true);

    setRecordingTime(0);
    intervalRef.current = setInterval(() => {
      setRecordingTime((prev) => {
        if (prev >= MAX_RECORDING_TIME) {
          stopRecording();
          return prev;
        }
        return prev + 1;
      });
    }, 1000);
  };

  const stopRecording = () => {
    mediaRecorderRef.current?.stop();
    setRecording(false);
    clearInterval(intervalRef.current);
  };

  const handleReset = () => {
    setVideoUrl(null);
    startCamera();
    setRecordingTime(0);
  };

  const progressPercent = Math.min(
    (recordingTime / MAX_RECORDING_TIME) * 100,
    100
  );

  return (
    <div>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {!videoUrl && (
        <>
          <video
            ref={videoRef}
            autoPlay
            muted
            playsInline
            style={{ width: "320px", height: "240px", background: "black" }}
          />
          {recording && (
            <div>
              <div style={{ height: "6px", background: "#ddd" }}>
                <div
                  style={{
                    width: `${progressPercent}%`,
                    height: "100%",
                    background: "#4caf50",
                  }}
                />
              </div>
              <div>{String(Math.floor(recordingTime / 60)).padStart(2, "0")}:{String(recordingTime % 60).padStart(2, "0")}</div>
            </div>
          )}
        </>
      )}

      <div>
        {!recording && !videoUrl && (
          <button onClick={startRecording}>Démarrer l'enregistrement</button>
        )}
        {recording && <button onClick={stopRecording}>Arrêter</button>}
        {videoUrl && <button onClick={handleReset}>Réenregistrer</button>}
      </div>

      {videoUrl && (
        <video src={videoUrl} controls style={{ width: "320px", height: "240px" }} />
      )}
    </div>
  );
}